export default {
    navigationBarTitleText: '代画户型'
};
  